import { render, staticRenderFns } from "./R21.vue?vue&type=template&id=5978146b&scoped=true"
import script from "./R21.vue?vue&type=script&lang=js"
export * from "./R21.vue?vue&type=script&lang=js"
import style0 from "./R21.vue?vue&type=style&index=0&id=5978146b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978146b",
  null
  
)

export default component.exports